import { supabase } from '@/integrations/supabase/client';
import { FunctionsFetchError } from '@supabase/supabase-js';

interface InvokeOptions {
  body?: Record<string, any>;
  headers?: Record<string, string>;
}

/**
 * Wrapper around supabase.functions.invoke that retries once on FunctionsFetchError
 */
export const invokeWithRetry = async (
  functionName: string,
  options?: InvokeOptions
) => {
  try {
    return await supabase.functions.invoke(functionName, options);
  } catch (error) {
    // Retry once if it's a FunctionsFetchError
    if (error instanceof FunctionsFetchError) {
      console.log(`Retrying function invoke for ${functionName} after FunctionsFetchError:`, error.message);
      return await supabase.functions.invoke(functionName, options);
    }
    throw error;
  }
};